import styled, { css } from 'styled-components';
import { PageTitle } from 'styles/sharedStyles';

export const ShoppingCartHead = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px 20px 0px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const Title = styled(PageTitle)``;

export const LoadingSpinnerWrapper = styled.div`
  padding: 15px;
`;

export const EmptyCartButtonLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 400;
  color: #000;
  cursor: pointer;
  margin-left: 4px;
`;

export const ShoppingCartContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;

export const ShoppingCartSection = styled.div<{
  isCustomClamShellOrder: boolean;
}>`
  overflow: auto;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 70%;
    overflow: unset;
  }

  > :first-child {
    margin: 0 0 10px 0;
  }

  ${({ isCustomClamShellOrder }) =>
    isCustomClamShellOrder &&
    `
  > :nth-child(n + 2) {
    border-radius: 0;
  }
  > :nth-child(2) {
    border-radius: 4px 4px 0 0;
  }
  > :nth-last-child(2) {
    border-radius: 0 0 4px 4px;
  }  
  `}
`;

export const CheckoutSection = styled.div`
  width: 25%;
  box-sizing: border-box;
  padding: 20px;
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius};
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    margin-top: 3%;
  }
  height: max-content;
`;

export const SubTotalTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  margin-bottom: 2%;
  color: rgba(0, 0, 0, 0.63);
`;

export const SubTotalPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5%;
`;

export const SubTotalWithDiscount = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 10px;
`;

export const TotalSavings = styled.div`
  color: #649942;
  font-weight: 500;
`;

// export const SubTotalPriceContainer = styled.div`
//   display: flex;
//   align-items: center;
// `;

// export const SubTotalWithDiscount = styled.div`
//   font-size: 1.5rem;
//   font-weight: 500;
//   margin-bottom: 5%;
//   ${({ theme }) => theme.breakpoints.down('md')} {
//     margin-bottom: 2%;
//   }
// `;

// export const SubTotal = styled.div<{ isBulkDiscountAvailable?: boolean }>`
//   font-size: ${({ isBulkDiscountAvailable }) =>
//     isBulkDiscountAvailable ? '1rem' : '1.5rem'};
//   font-weight: 500;
//   margin-bottom: 5%;
//   ${({ theme }) => theme.breakpoints.down('md')} {
//     margin-bottom: 2%;
//   }
//   text-decoration: ${({ isBulkDiscountAvailable }) =>
//     isBulkDiscountAvailable ? 'line-through' : 'none'};
//   color: ${({ isBulkDiscountAvailable }) =>
//     isBulkDiscountAvailable ? 'rgba(0, 0, 0, 0.63)' : '#000'};
//   margin-left: ${({ isBulkDiscountAvailable }) =>
//     isBulkDiscountAvailable ? '5px' : '0px'};
// `;

const getGridColumns = (isRewardPointsAvailable?: boolean) => {
  if (isRewardPointsAvailable) {
    return css`
      grid-template-columns: 0.8fr 2fr 1fr 1fr 1.2fr 1fr 0.5fr;
    `;
  } else {
    return css`
      grid-template-columns: 0.8fr 3fr 1fr 1.2fr 1fr 0.5fr;
    `;
  }
};

export const LineItemHeader = styled.div<{
  isRewardPointsAvailable?: boolean;
}>`
  box-sizing: border-box;
  display: grid;
  ${({ isRewardPointsAvailable }) => {
    return getGridColumns(isRewardPointsAvailable);
  }};
  width: max(700px, 100%);
  background: white;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 3px 5px;
  > div:first-of-type {
    margin-left: 10px;
  }
`;

export const LineItemHeaderTitle = styled.div`
  font-size: 0.8rem;
  font-weight: 400;
  padding: 10px 0px;
  color: rgba(0, 0, 0, 0.63);
`;

export const LineItemContainer = styled(LineItemHeader)<{
  disabled: boolean;
  isCustomClamShellOrder?: boolean;
  isRewardPointsAvailable?: boolean;
}>`
  ${({ isRewardPointsAvailable }) => {
    return getGridColumns(isRewardPointsAvailable);
  }};
  margin-top: ${({ isCustomClamShellOrder }) =>
    isCustomClamShellOrder ? '0' : '10px'};
  background: ${({ disabled }) => (disabled ? 'rgba(0,0,0,0.05)' : 'white')};
  > .tooltip {
    width: 300px;
    font-size: 0.8rem;
  }
  padding: 5px 0px;
`;

export const CustomClamShellSummary = styled.div`
  box-sizing: border-box;
  display: grid;

  width: max(700px, 100%);
  background: white;
  align-items: center;

  > div:first-of-type {
    margin-left: 10px;
  }
  grid-template-columns: 0.8fr 3fr 1fr 1.2fr 1fr 0.5fr;
`;

export const SummaryItem = styled.div<{ highlighted?: boolean }>`
  text-decoration: underline;
  margin: 10px 0;
  color: ${({ highlighted }) =>
    highlighted ? 'inherited' : 'rgba(0, 0, 0, 0.63)'};
  ${({ highlighted }) => highlighted && 'font-weight: 600;'}
  font-weight: 600;
`;

export const EditDesignButton = styled.div`
  margin: 10px 0 0 0;
  display: flex;
  justify-content: flex-end;
`;
export const LineItemThumbnail = styled.div<{
  isCustomClamShellOrder?: boolean;
}>`
  position: relative;
  width: 80px;
  height: 80px;
  margin: 10px 10px 10px 10px;
  cursor: pointer;
  left: ${({ isCustomClamShellOrder }) =>
    isCustomClamShellOrder ? '25px' : '0px'};
`;

export const Link = styled.a`
  display: inline;
`;

export const PreviewContainer = styled.div`
  color: rgba(32, 154, 214, 1);
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ModalContainer = styled.div``;

export const ModalHeader = styled.div`
  margin-top: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
`;

export const ModalBody = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalFooter = styled.div`
  padding-bottom: 40px;
`;

export const PreviewLoadingContainer = styled.div`
  box-sizing: border-box;
  padding: 50px;
`;

export const PreviewImageOverlay = styled.div``;

export const ClamshellPreviewThumbnail = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  margin: 10px 10px 10px 10px;
  cursor: pointer;
  z-index: 5;
`;

export const LineItemDescription = styled.div<{
  isCustomClamShellOrder?: boolean;
}>`
  font-weight: 500;
  width: 90%;
  margin-left: ${({ isCustomClamShellOrder }) =>
    isCustomClamShellOrder ? '20px' : '0px'};
`;

export const Availibility = styled.p<{
  inStock: boolean;
  isCustomClamShellOrder?: boolean;
}>`
  ${({ theme }) => theme.breakpoints.down('md')} {
    margin: 1rem 0 0 0;
  }

  font-weight: 400;
  font-size: 0.8rem;
  color: ${({ inStock, theme }) =>
    inStock ? theme.palette.text.success : 'rgba(212, 63, 88, 1)'};
  display: ${({ isCustomClamShellOrder }) =>
    isCustomClamShellOrder ? 'none' : 'inline'};
`;

export const ExpirationDate = styled.div`
  font-weight: 500;
  color: rgba(212, 63, 88, 1);
  font-size: 0.8rem;
`;

export const DesignName = styled(SummaryItem)`
  font-weight: 600;
`;

export const LineItemDiscountsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  padding: 6px 8px;
  background: #f0f7f0;
  border-radius: 4px;
  width: fit-content;
`;

export const DiscountContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const AvailableDiscounts = styled.div`
  font-size: 0.8rem;
  font-weight: 500;
  color: #555;
  > div p {
    padding: 0px;
    margin: 0px;
  }
`;

export const DiscountApplied = styled.div`
  font-weight: 600;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.palette.text.success};
  margin-left: 10px;
`;

export const LineItemPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LineItemPrice = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.63);
  text-decoration: none;
  font-size: inherit;
`;

export const LineItemDiscountedPrice = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.63);
`;

export const LineItemDiscountMessage = styled.div`
  color: #388e3c;
`;

export const LineItemAttributes = styled.div`
  display: flex;
  align-items: center;
`;

export const LineItemQuantity = styled.div`
  width: 40%;

  /* ${({ theme }) => theme.breakpoints.down('md')} {
    width: calc(100% - 10px);
    margin-left: 5px;
  } */
`;

export const LineItemTotal = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 500;
`;

export const LineItemTotalWithoutDiscount = styled.div`
  font-weight: 300;
  font-size: 0.8rem;
  text-decoration: line-through;
`;

export const EmptyCartMessage = styled.div`
  width: 100%;
  font-size: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CheckoutAlertMessage = styled.p`
  font-size: 0.9 rem;
`;

export const TCWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  > input {
    width: 60px;
    height: 60px;
    margin-right: 10px;
  }
  > div {
    margin-left: 3px;
  }

  > label {
    cursor: pointer;
  }
`;

export const Divider = styled.div`
  border-width: 0px 0px thin;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.05);
`;

export const ClamshellLineitemsWrapper = styled.div`
  padding-left: 100px;
`;

export const DisclaimerCustom = styled.div`
  font-size: 0.85rem;
  text-align: center;
`;

export const SubscriptionDisclaimer = styled.div`
  font-size: 0.8rem;
  font-weight: 500;
  color: #388e3c;
`;

export const PercentageSaved = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: #2e7d32;
`;

export const CouponDiscount = styled.div``;

export const CouponCode = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #555;
  font-weight: 400;
  font-size: 0.8rem;
`;
export const DiscountAmount = styled.div`
  margin-left: 5px;
`;
